import { useEffect } from "react";

/**
 * Tiny SEO hook to set <title> and meta description per route.
 * Keeps things lightweight without pulling react-helmet.
 */
export default function useSeo({ title, description }) {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      let tag = document.querySelector('meta[name="description"]');
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute("name", "description");
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", description);
    }
  }, [title, description]);
}
